function withBreakoutContainer(spec, divAttributes) {
  return ["div", { ...divAttributes }, spec];
}
export {
  withBreakoutContainer
};
//# sourceMappingURL=withBreakoutContainer.js.map
